// extracted by mini-css-extract-plugin
export default {"AddressList":"Xxl1Q"};